import React from "react";
import { Row, Skeleton, Typography } from "antd";
import moment from "moment/moment";

import { Countries } from "../../countries";

import "@Styles/pages/connectionsPage.scss";

interface IProps {
    render: boolean;
    fullName: string;
    countryCode: string;
    organisation: string;
    connectionDate: string | null;
}

const { Text } = Typography;

const ProfileCompact: React.FC<IProps> = ({ render, fullName, countryCode, organisation, connectionDate }) => {
    return (
        <section>
            <Row className="profile-compact">
                {render ? (
                    <div>
                        <div>
                            <Text strong>{fullName}.</Text>
                            <span className={"meta"}>
                                {Countries.get(countryCode)}
                                {organisation?.length > 0 ?? <>&nbsp;&middot;&nbsp; {organisation}</>}
                            </span>
                        </div>
                        <div className={"connection-info"}>
                            {connectionDate && (
                                <span className={"connection-date"}>Connected {moment(connectionDate).fromNow()}</span>
                            )}
                        </div>
                    </div>
                ) : (
                    <div>
                        <Skeleton.Input active={true} size={"large"} />
                    </div>
                )}
            </Row>
        </section>
    );
};
export default ProfileCompact;
